import React from 'react';
import nodata from "../../../assets/image/nodata.jpg";
import lionImg from "../../../assets/headerpage-icon/404.png"
import { useHistory } from "react-router-dom";

const NoImageFound = () => {
  const history = useHistory();
  const sendBack = () => {
    history.push('/homepage')
  }
  return (
    <>
    <div className='error-layout'>
      <div className="error-container">
      <div className="row">
        <div className="col-md-6">
          <div className="error-left h-100">
          <div className="error-content">
            <h2>404</h2>
            <div className="error-desc">
              <h4>No results found</h4>
              <p>We couldn’t find what you searched for. <br />Try searching again. </p>
              <button className="cont-us" onClick={sendBack}>Back to Home</button>
            </div>
          </div>
          </div>
        </div>
        <div className="col-md-6">
          <div className="error-img">
            <img src={lionImg} alt="" className='img-fluid' />
          </div>
        </div>
      </div>
      </div>
      </div>

      
      {/* <div>

      <div className="nofound_clas">
              <img src={nodata} alt="random" />
          </div>
  </div> */}
    </>
     
  )
}

export default NoImageFound